import React from "react";
import "../../styles/ContactSerene.css";
import bgImage from "../../assets/woods-images/contact-bg-woods.jpg";
import { motion } from "framer-motion";

export default function ContactSerene() {
  // ✅ Section + Card stagger
  const cardStagger = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.1,
      },
    },
  };

  // ✅ Bottom → top
  const fadeUp = {
    hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.9, ease: "easeOut" },
    },
  };

  // ✅ Word by word title animation
  const wordContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.15,
      },
    },
  };

  const wordVariant = {
    hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
    show: {
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  // ✅ Title split into 2 lines
  const line1 = "Begin Your Journey".split(" ");
  const line2 = "Today".split(" ");

  return (
    <section id="serene-contact" className="contact-serene">
      {/* Background image */}
      <div
        className="contact-bg"
        style={{ backgroundImage: `url(${bgImage})` }}
      ></div>

      {/* Centered card */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            {/* ✅ Animated Contact Card */}
            <motion.div
              className="contact-card text-white rounded-3 p-4 p-md-5"
              variants={cardStagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.4 }}
            >
              <div className="row g-4 g-md-5">
                {/* LEFT */}
                <div className="col-lg-6">
                  {/* ✅ Title word-by-word */}
                  <motion.h2
                    className="contact-titles display-4 mb-4"
                    variants={wordContainer}
                  >
                    {line1.map((word, i) => (
                      <motion.span
                        key={`line1-${i}`}
                        variants={wordVariant}
                        style={{
                          display: "inline-block",
                          marginRight: "0.35em",
                        }}
                      >
                        {word}
                      </motion.span>
                    ))}
                    <br />
                    {line2.map((word, i) => (
                      <motion.span
                        key={`line2-${i}`}
                        variants={wordVariant}
                        style={{
                          display: "inline-block",
                          marginRight: "0.35em",
                        }}
                      >
                        {word}
                      </motion.span>
                    ))}
                  </motion.h2>

                  <motion.p className="contact-text" variants={fadeUp}>
                    Share your details and help us understand your requirements.
                    Explore thoughtfully crafted homes designed for refined living.
                    Receive personalized assistance from our experienced team.
                    We’ll get in touch to guide you every step of the way.
                  </motion.p>
                </div>

                {/* RIGHT */}
                <div className="col-lg-6">
                  <motion.div className="contact-form" variants={fadeUp}>
                    {/* INPUTS */}
                    <motion.div className="mb-3" variants={fadeUp}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                      />
                    </motion.div>

                    <motion.div className="mb-3" variants={fadeUp}>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="+91 (0000) 000-000"
                      />
                    </motion.div>

                    <motion.div className="mb-3" variants={fadeUp}>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Your email"
                      />
                    </motion.div>

                    {/* MESSAGE */}
                    <motion.div className="mb-4" variants={fadeUp}>
                      <textarea
                        className="form-control"
                        placeholder="Your message"
                        rows="4"
                      />
                    </motion.div>

                    <motion.button
                      className="location-btn"
                      variants={fadeUp}
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                    >
                      Send Message
                      <i className="fa-solid fa-arrow-right ms-2"></i>
                    </motion.button>
                  </motion.div>
                </div>
              </div>
            </motion.div>
            {/* ✅ end card */}
          </div>
        </div>
      </div>
    </section>
  );
}
